import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { GrupoComprador } from 'src/app/models/api/comercial/grupo-comprador';

@Injectable({
  providedIn: 'root'
})
export class ApiGrupoCompradorService {
  private baseUrl = 'GrupoComprador';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<GrupoComprador[]>('');
  }

  insert(data: GrupoComprador) {
    return this.controller.unwrap().post<GrupoComprador>('', data);
  }

  update(data: GrupoComprador) {
    return this.controller.unwrap().put<GrupoComprador>('', data);
  }

  delete(id: string) {
    if (!id) { throw new Error('Invalid Argument'); }
    return this.controller.delete(id);
  }
}
